import { render, staticRenderFns } from "./charges.vue?vue&type=template&id=0a8e4ccb&lang=pug&"
import script from "./charges.vue?vue&type=script&lang=js&"
export * from "./charges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/currents?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230331143208%2Fcomponents%2Fproducts%2Fcurrents%2Fcharges.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports